<template>
  <div v-if="depth === 0">
    <o-tabs
      v-if="tabs.length"
      :model-value="activeTab"
      size="small"
      type="boxed"
      class="tab-header"
      :animated="false"
      @update:modelValue="changeRoute"
    >
      <o-tab-item
        v-for="(tab, idx) in tabs"
        :key="tab.name || idx"
        :label="tab.title"
        :value="idx"
      >
        <template v-if="activeTab === idx">
          <div :class="tab.tabsClassName">
            <SettingsTabsWrapper
              v-if="hasDeeper"
              :depth="depth + 1"
            />
            <router-view v-else />
          </div>
        </template>
      </o-tab-item>
    </o-tabs>

    <router-view v-else />
  </div>

  <div
    v-else-if="tabs.length" 
  >
    <div
      v-if="isCompanySettings"
    >
    </div>

    <o-tabs
      :model-value="activeTab"
      size="small"
      class="tab-header"
      :animated="false"
      :vertical="depth === 2"
      :type="depth === 2 ? 'toggle' : 'boxed'"
      @update:modelValue="changeRoute"
    >
      <o-tab-item
        v-for="(tab, idx) in tabs"
        :key="tab.name || idx"
        :label="tab.title"
        :value="idx"
        :icon="tab?.meta?.icon"
      >
        <template v-if="activeTab === idx">
          <SettingsTabsWrapper
            v-if="hasDeeper"
            :depth="depth + 1"
            :isVertical="depth + 1 === 2"
          />
          <router-view v-else />
        </template>
      </o-tab-item>
    </o-tabs>
  </div>

  <router-view v-else />
</template>
<script>
import { computed, defineComponent, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { findIndex } from 'lodash';
import Templates from './Templates.vue';

export default defineComponent({
  components: { Templates },
  name: 'SettingsTabsWrapper',
  props: {
    depth: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const isActivityActive = ref(false);
    const parentRecord = computed(() => route.matched[props.depth] || null);
    const tabs = computed(() =>
      parentRecord.value && parentRecord.value.children
        ? parentRecord.value.children.filter((c) => {
          try {
            let hasChildrensPermission = false
            const key = _.get(c, 'meta.permissionKey', '')
            if (!_.isEmpty(c.children)) {
              let childKey = null
              hasChildrensPermission = _.some(c.children, (subChild) => {
                childKey = _.get(subChild, 'meta.permissionKey', '')
                return store.getters.hasCompanyPermissionForModule(childKey);
              })
              if (_.isEmpty(key) || (!_.isEmpty(key) && key === 'app&projects:company_profile') && store.getters.hasCompanyPermissionForModule(key)) {
                return hasChildrensPermission
              }
            }
            if (!_.isEmpty(key)) {
              if (['app&projects:projects'].includes(key)) {
                return store.getters.hasCompanyPermissionForModule(key);
              } else if (key === 'app&projects:analytics') {
                return store.getters.hasCompanyPermissionForModule(key)
                  && (store.state.companyData?.subscriptions || []).includes('sqlExport');
              } else {
                return store.getters.hasPermissionForModule(key);
              }
            }
            return !c.meta || !c.meta.hidden
          } catch (e) {
            console.log('Error: ', e)
          }
        }) : []);
    const nextRecord = computed(() => route.matched[props.depth + 1] || null);
    const activeTab = computed(() => {
      if (!nextRecord.value) return 0;
      const i = findIndex(
        tabs.value,
        (t) => t.name === nextRecord.value.name
      );
      return i >= 0 ? i : 0;
    });
    const hasDeeper = computed(() => {
      const next = nextRecord.value;
      return !!(next && next.children && next.children.length);
    });
    const isCompanySettings = computed(() => {
      return (
        props.depth === 1 &&
        parentRecord.value?.name === 'CompanySettings'
      );
    });
    const companyId = computed(() => store.state.userData?.company || '');

    const buildPath = (target) => {
      const parentPath = parentRecord.value ? parentRecord.value.path : '';
      const child = target.path || '';
      const key = _.get(target, 'meta.permissionKey')
      if (key === 'app&projects:company_profile') {
        const tabToRedirect = target.children.filter((c) => {
          const key = _.get(c, 'meta.permissionKey', '')
          return store.getters.hasCompanyPermissionForModule(key);
        })
        if (!_.isEmpty(tabToRedirect)) {
          return `${parentPath.replace(/\/$/, '')}/${child}/${tabToRedirect[0].path}`
        }
      }
      if (child.startsWith('/')) return child;
      return `${parentPath.replace(/\/$/, '')}/${child}`;
    };

    const changeRoute = async (idx) => {
      const target = tabs.value[idx];
      if (!target) return;
      isActivityActive.value = false;
      await router.push({
        path: buildPath(target),
      });
    };

    return {
      tabs,
      activeTab,
      hasDeeper,
      changeRoute,
      isActivityActive,
      isCompanySettings,
      companyId,
    };
  },
});
</script>